import React from 'react';
import { Container, Description, Item } from './styles';

import { ReactComponent as CalendarSmIcon } from '../../assets/calendar-sm.svg';
import { ReactComponent as LocationSmIcon } from '../../assets/location-sm.svg';
import { ReactComponent as CameraSmIcon } from '../../assets/camera-sm.svg';
import { ReactComponent as UserSmIcon } from '../../assets/user-sm.svg';
import { ReactComponent as EligibilitySmIcon } from '../../assets/eligibility-sm.svg';

import { HeadProduct } from '../HeadProduct';
import { HorizontalLine } from '../HorizontalLine';
import { ExecutiveCheckupIcon } from '../Icons/Services/ExecutiveCheckup';
import { formatDatetime } from '../../utils/dates';

type ScheduleData = {
  patientName: string;
  productName?: string;
  productNameHead: string;
  productDescription: string;
  eligibility?: string;
  date: Date;
  unitName: string;
  unitAddress: string;
  customCardHead?: React.ReactNode;
  productIconSM?: React.ReactNode;
  telemedicine?: boolean;
};

export const AppointmentConfirmationCard = ({
  productNameHead,
  patientName,
  productName,
  productDescription,
  eligibility,
  date,
  unitAddress,
  unitName,
  customCardHead,
  productIconSM,
  telemedicine
}: ScheduleData) => {
  const capitalizePhrase = (phrase: string) => {
    phrase = phrase.toLocaleLowerCase();
    const phraseSplitted = phrase.split(' ');

    const wordsCapitalized = phraseSplitted.map(word => word.charAt(0).toUpperCase() + word.slice(1));

    return wordsCapitalized.join(' ');
  };

  return (
    <Container>
      {!customCardHead ? (
        <>
          <HeadProduct name={productNameHead} description={productDescription} productIcon={<ExecutiveCheckupIcon />} />
          <HorizontalLine />
        </>
      ) : (
        customCardHead
      )}

      <Item>
        <UserSmIcon />
        <p>{patientName}</p>
      </Item>

      {productName && productIconSM && (
        <Item>
          {productIconSM}
          <p>{productName}</p>
        </Item>
      )}

      <Item>
        <CalendarSmIcon />
        <p>{formatDatetime(date)}</p>
      </Item>

      {eligibility && (
        <Item>
          <EligibilitySmIcon />
          <p>{eligibility}</p>
        </Item>
      )}

      {telemedicine ? (
        <Item>
          <CameraSmIcon />
          <p>Consulta por telemedicina</p>
        </Item>
      ) : (
        <>
          <Item>
            <LocationSmIcon />
            <p>{capitalizePhrase(unitName)}</p>
          </Item>
          <Description>{unitAddress}</Description>
        </>
      )}
    </Container>
  );
};
